import { ReactionType } from '../model/post.types';

export const reactionPickerRows: ReactionType[][] = [
  [
    ReactionType.Heart,
    ReactionType.Rocket,
    ReactionType.Goat,
    ReactionType.Fire,
    ReactionType.Tada,
  ],
  [
    ReactionType.ThumbsUp,
    ReactionType.Horns,
    ReactionType.Clap,
    ReactionType.Muscle,
    ReactionType.RaisedHands,
  ],
  [
    ReactionType.OpenMouth,
    ReactionType.Joy,
    ReactionType.Cry,
    ReactionType.Disappointed,
    ReactionType.FaceHearts,
  ],
];
